var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWaiting = function SvgWaiting(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ED7760",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 4.995c7.182 0 13.005 5.823 13.005 13.005S25.182 31.005 18 31.005 4.995 25.182 4.995 18 10.818 4.995 18 4.995M18 0C8.059 0 0 8.059 0 18s8.059 18 18 18 18-8.059 18-18A18 18 0 0 0 18 0z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 2.98c-8.277 0-14.986 6.71-14.986 14.987 0 8.276 6.71 14.986 14.986 14.986 8.277 0 14.986-6.71 14.986-14.986C32.986 9.69 26.276 2.98 18 2.98zm1.365 14.804v.1c.04.386-.095.77-.366 1.048l-3.33 3.514a1.366 1.366 0 0 1-1.965-1.898l2.947-3.114v-6.477a1.365 1.365 0 0 1 2.731 0l-.017 6.827z",
    opacity: 0.65
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWaiting);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/waiting.4e788eb0c90ab3cb260303272688f763.svg";